import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-json-popup',
  templateUrl: './json-popup.component.html',
  styleUrls: ['./json-popup.component.css']
})
export class JsonPopupComponent {
  @Input() visible: boolean = false;
  @Input() title: string = 'JSON Data';
  @Input() jsonData: any = null;
  @Input() enableLinkFormatting: boolean = true;
  @Input() editable: boolean = false;
  @Input() identifier: string = '';
  @Output() close = new EventEmitter<void>();
  @Output() update = new EventEmitter<any>();
  @Output() identifierChange = new EventEmitter<string>();

  public animationState: 'hidden' | 'showing' | 'hiding' = 'hidden';
  public isEditing: boolean = false;
  public editedJsonString: string = '';
  public jsonError: string = '';
  public editedIdentifier: string = '';

  ngOnChanges() {
    if (this.visible) {
      // Reset editing state when popup becomes visible
      this.isEditing = false;
      this.jsonError = '';
      this.editedIdentifier = this.identifier || '';
      // Small delay to ensure the element is rendered before animating
      setTimeout(() => {
        this.animationState = 'showing';
      }, 10);
    } else if (this.animationState === 'showing') {
      // Start hiding animation
      this.animationState = 'hiding';
      // Wait for animation to complete before removing
      setTimeout(() => {
        this.animationState = 'hidden';
      }, 300); // Match the CSS transition duration
    }
  }

  public getFormattedJson(): string {
    if (!this.jsonData) return '';

    const jsonString = JSON.stringify(this.jsonData, null, 2);

    if (this.enableLinkFormatting) {
      // Regex to match HTTP and HTTPS URLs within JSON string values
      const urlRegex = /"(https?:\/\/[^"]+)"/g;
      // Replace URLs with anchor tags
      return jsonString.replace(urlRegex, '"<a href=\'$1\' target=\'_blank\' rel=\'noopener noreferrer\' style=\'color: #0066cc; text-decoration: underline;\'>$1</a>"');
    }

    return jsonString;
  }

  public onClose() {
    this.close.emit();
  }

  public startEditing() {
    this.isEditing = true;
    this.editedJsonString = JSON.stringify(this.jsonData, null, 2);
    this.jsonError = '';
  }

  public cancelEditing() {
    this.isEditing = false;
    this.editedJsonString = '';
    this.jsonError = '';
    this.editedIdentifier = this.identifier || '';
  }

  public saveChanges() {
    try {
      // Validate JSON
      const parsedData = JSON.parse(this.editedJsonString);
      this.jsonError = '';
      
      // Emit the updated data with identifier
      this.update.emit({
        metadata: parsedData,
        identifier: this.editedIdentifier
      });
      
      // Exit edit mode
      this.isEditing = false;
      this.editedJsonString = '';
    } catch (error) {
      // Show error message if JSON is invalid
      this.jsonError = 'Invalid JSON: ' + error.message;
    }
  }
}

